import { create } from 'zustand';
import type { UIState, Notification } from './types';

type UIStore = UIState & {
  // Sidebar actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  // Theme actions
  setTheme: (theme: 'light' | 'dark') => void;

  // Notification actions
  addNotification: (notification: Omit<Notification, 'id' | 'timestamp'>) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
};

export const useUIStore = create<UIStore>((set) => ({
  // Initial state
  sidebarOpen: true,
  theme: 'light',
  notifications: [],

  // Sidebar actions
  toggleSidebar: () =>
    set((state) => ({
      sidebarOpen: !state.sidebarOpen,
    })),

  setSidebarOpen: (open: boolean) =>
    set(() => ({
      sidebarOpen: open,
    })),

  // Theme actions
  setTheme: (theme: 'light' | 'dark') =>
    set(() => ({
      theme,
    })),

  // Notification actions
  addNotification: (notification) =>
    set((state) => ({
      notifications: [
        ...state.notifications,
        {
          ...notification,
          id: `${Date.now()}-${Math.random()}`,
          timestamp: Date.now(),
        },
      ],
    })),

  removeNotification: (id: string) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),

  clearNotifications: () =>
    set(() => ({
      notifications: [],
    })),
}));
